import styled from 'styled-components';

export const SectionContainer = styled.div`
  background-color: #1a1a1a;
  width: 100%;

  @media (max-width: 768px) {
    padding: 40px 0 56px 0;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 1369px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0;
    max-width: 340px;
    gap: 20px;
  }

  h1 {
    color: #c3c3c3;
    font-size: 32px;
    font-style: normal;
    font-weight: 275;
    line-height: 40px;

    @media (max-width: 768px) {
      font-size: 18px;
      line-height: 32px;
    }
  }

  span {
    color: #f16024;
  }
`;

export const StyledHr = styled.hr`
  flex: 1;
  border: 1px solid #c3c3c3;
  margin: 0 20px;

  @media (max-width: 768px) {
    margin: 0;
  }
`;

export const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  max-width: 1180px;
  margin: 80px auto 0 auto;
  padding: 70px 0 10px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    max-width: 340px;
    margin: 0 auto;
    padding: 0;
  }
`;

export const TextBox1 = styled.div`
  p {
    color: #e4e4e4;
    font-family: Barlow;
    font-size: 32px;
    font-style: normal;
    font-weight: 300;
    line-height: 40px;
    padding: 0 280px 0 0;
    margin: 0;

    @media (max-width: 768px) {
      padding-right: 20px;
      font-size: 22px;
      font-style: normal;
      font-weight: 300;
      line-height: 24px;
      margin-top: 24px;
    }
  }
`;

export const TextBox2 = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding-top: 30px;
  }

  h2 {
    font-family: 'Barlow';
    font-size: 22px;
    font-style: normal;
    font-weight: 275;
    line-height: 28px;
    padding-bottom: 10px;
  }

  p {
    font-family: 'Open Sans';
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px;
    color: #c3c3c3;
  }

  .grid-content {
    padding: 0 110px 48px 0;

    @media (max-width: 768px) {
      padding: 0 20px 0px 0;
    }
  }
`;
